import { formatCurrencyForDisplay } from '@utils'
import {
  selectCurrentUserId,
  useAppSelector,
  useCurrencies,
  useLazyGetUserExpenseLimitsQuery
} from 'mmfintech-backend-api'
import { formatFloat, tr } from 'mmfintech-commons'
import { useEffect, useMemo } from 'react'

import './spendingLimitBarUser.scss'

export const SpendingLimitBarUser = () => {
  const { getCurrencyPrecision } = useCurrencies()

  const [getUserExpenseLimits, { data: userExpenseLimits }] = useLazyGetUserExpenseLimitsQuery()
  const userId = useAppSelector(selectCurrentUserId)

  const { availableMonthlyVolume, monthlyVolume, currency, spentMonthlyVolume } = userExpenseLimits || {}
  useEffect(() => {
    if (userId) {
      getUserExpenseLimits({ merchantUserId: userId })
    }
  }, [userId])

  const availableMonthlyVol = availableMonthlyVolume > 0 ? availableMonthlyVolume : 0
  const progressPercentage = monthlyVolume ? 100 - (availableMonthlyVol / monthlyVolume) * 100 : 100

  const progressBarColor = useMemo(() => {
    if (monthlyVolume) {
      return progressPercentage <= 50 ? 'green' : progressPercentage <= 80 ? 'orange' : 'red'
    } else {
      return 'blue'
    }
  }, [monthlyVolume, progressPercentage])

  if (!userExpenseLimits) {
    return null
  }

  return (
    <div className={`progress-bar-wrapper-container${!monthlyVolume ? ' no-limit' : ''}`}>
      <div className={`progress-bar-info-wrapper${!monthlyVolume ? ' no-limit' : ''}`}>
        <div className='money-spent'>
          <span className='info-text'>
            {tr('FRONTEND.USERS.EXPENSE_MANAGEMENT.DASHBOARD.MONEY_SPENT', 'Money Spent:')}
          </span>
          {formatFloat(spentMonthlyVolume, getCurrencyPrecision(currency))}{' '}
          <span className='currency'>{formatCurrencyForDisplay(currency)}</span>
        </div>
        {monthlyVolume ? (
          <div className='monthly-limit'>
            <span className='info-text'>
              {tr('FRONTEND.USERS.EXPENSE_MANAGEMENT.DASHBOARD.MONTHLY_LIMIT', 'Monthly Limit:')}{' '}
            </span>
            {formatFloat(monthlyVolume, getCurrencyPrecision(currency))}{' '}
            <span className='currency'>{formatCurrencyForDisplay(currency)}</span>
          </div>
        ) : null}
      </div>
      {monthlyVolume ? (
        <div className={`progress-bar-with-info-wrapper `}>
          {progressPercentage > 0 && (
            <div style={{ width: `${progressPercentage}%` }} className={`progress-bar ${progressBarColor}`} />
          )}
        </div>
      ) : null}
    </div>
  )
}
